var cov_1j10ih41en = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Table/Tr.tsx",
      hash = "ea3a5c6f6ed91be5bd0a2230defaff86cb7a69f9",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Table/Tr.tsx",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 39
        },
        end: {
          line: 11,
          column: 69
        }
      },
      "1": {
        start: {
          line: 13,
          column: 23
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "2": {
        start: {
          line: 19,
          column: 28
        },
        end: {
          line: 26,
          column: 1
        }
      },
      "3": {
        start: {
          line: 20,
          column: 22
        },
        end: {
          line: 20,
          column: 24
        }
      },
      "4": {
        start: {
          line: 21,
          column: 2
        },
        end: {
          line: 21,
          column: 55
        }
      },
      "5": {
        start: {
          line: 21,
          column: 44
        },
        end: {
          line: 21,
          column: 55
        }
      },
      "6": {
        start: {
          line: 22,
          column: 2
        },
        end: {
          line: 22,
          column: 82
        }
      },
      "7": {
        start: {
          line: 22,
          column: 70
        },
        end: {
          line: 22,
          column: 82
        }
      },
      "8": {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 23,
          column: 70
        }
      },
      "9": {
        start: {
          line: 23,
          column: 31
        },
        end: {
          line: 23,
          column: 55
        }
      },
      "10": {
        start: {
          line: 23,
          column: 58
        },
        end: {
          line: 23,
          column: 70
        }
      },
      "11": {
        start: {
          line: 24,
          column: 2
        },
        end: {
          line: 24,
          column: 37
        }
      },
      "12": {
        start: {
          line: 24,
          column: 25
        },
        end: {
          line: 24,
          column: 37
        }
      },
      "13": {
        start: {
          line: 25,
          column: 2
        },
        end: {
          line: 25,
          column: 46
        }
      },
      "14": {
        start: {
          line: 27,
          column: 21
        },
        end: {
          line: 30,
          column: 1
        }
      },
      "15": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 53,
          column: 16
        }
      },
      "16": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 54,
          column: 29
        }
      },
      "17": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 55,
          column: 50
        }
      },
      "18": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 56,
          column: 56
        }
      },
      "19": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 52
        }
      },
      "20": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 58
        }
      },
      "21": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 59,
          column: 25
        }
      },
      "22": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 63,
          column: 28
        }
      },
      "23": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 64,
          column: 23
        }
      },
      "24": {
        start: {
          line: 68,
          column: 71
        },
        end: {
          line: 68,
          column: 81
        }
      },
      "25": {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 74,
          column: 5
        }
      },
      "26": {
        start: {
          line: 70,
          column: 19
        },
        end: {
          line: 70,
          column: 76
        }
      },
      "27": {
        start: {
          line: 70,
          column: 70
        },
        end: {
          line: 70,
          column: 76
        }
      },
      "28": {
        start: {
          line: 71,
          column: 6
        },
        end: {
          line: 73,
          column: 8
        }
      },
      "29": {
        start: {
          line: 72,
          column: 8
        },
        end: {
          line: 72,
          column: 27
        }
      },
      "30": {
        start: {
          line: 78,
          column: 55
        },
        end: {
          line: 78,
          column: 65
        }
      },
      "31": {
        start: {
          line: 79,
          column: 4
        },
        end: {
          line: 79,
          column: 55
        }
      },
      "32": {
        start: {
          line: 79,
          column: 49
        },
        end: {
          line: 79,
          column: 55
        }
      },
      "33": {
        start: {
          line: 80,
          column: 21
        },
        end: {
          line: 80,
          column: 57
        }
      },
      "34": {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 81,
          column: 62
        }
      },
      "35": {
        start: {
          line: 81,
          column: 30
        },
        end: {
          line: 81,
          column: 62
        }
      },
      "36": {
        start: {
          line: 82,
          column: 4
        },
        end: {
          line: 82,
          column: 65
        }
      },
      "37": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 86,
          column: 5
        }
      },
      "38": {
        start: {
          line: 84,
          column: 6
        },
        end: {
          line: 84,
          column: 65
        }
      },
      "39": {
        start: {
          line: 85,
          column: 6
        },
        end: {
          line: 85,
          column: 12
        }
      },
      "40": {
        start: {
          line: 87,
          column: 4
        },
        end: {
          line: 93,
          column: 12
        }
      },
      "41": {
        start: {
          line: 93,
          column: 6
        },
        end: {
          line: 93,
          column: 12
        }
      },
      "42": {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 94,
          column: 31
        }
      },
      "43": {
        start: {
          line: 95,
          column: 4
        },
        end: {
          line: 95,
          column: 37
        }
      },
      "44": {
        start: {
          line: 96,
          column: 4
        },
        end: {
          line: 96,
          column: 45
        }
      },
      "45": {
        start: {
          line: 97,
          column: 4
        },
        end: {
          line: 97,
          column: 72
        }
      },
      "46": {
        start: {
          line: 101,
          column: 4
        },
        end: {
          line: 101,
          column: 30
        }
      },
      "47": {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 102,
          column: 40
        }
      },
      "48": {
        start: {
          line: 106,
          column: 29
        },
        end: {
          line: 106,
          column: 39
        }
      },
      "49": {
        start: {
          line: 107,
          column: 16
        },
        end: {
          line: 107,
          column: 63
        }
      },
      "50": {
        start: {
          line: 108,
          column: 4
        },
        end: {
          line: 110,
          column: 5
        }
      },
      "51": {
        start: {
          line: 109,
          column: 6
        },
        end: {
          line: 109,
          column: 28
        }
      },
      "52": {
        start: {
          line: 111,
          column: 4
        },
        end: {
          line: 111,
          column: 45
        }
      },
      "53": {
        start: {
          line: 111,
          column: 25
        },
        end: {
          line: 111,
          column: 43
        }
      },
      "54": {
        start: {
          line: 115,
          column: 4
        },
        end: {
          line: 115,
          column: 21
        }
      },
      "55": {
        start: {
          line: 119,
          column: 29
        },
        end: {
          line: 119,
          column: 39
        }
      },
      "56": {
        start: {
          line: 120,
          column: 4
        },
        end: {
          line: 120,
          column: 42
        }
      },
      "57": {
        start: {
          line: 120,
          column: 31
        },
        end: {
          line: 120,
          column: 42
        }
      },
      "58": {
        start: {
          line: 121,
          column: 4
        },
        end: {
          line: 121,
          column: 63
        }
      },
      "59": {
        start: {
          line: 121,
          column: 44
        },
        end: {
          line: 121,
          column: 62
        }
      },
      "60": {
        start: {
          line: 135,
          column: 8
        },
        end: {
          line: 135,
          column: 18
        }
      },
      "61": {
        start: {
          line: 136,
          column: 19
        },
        end: {
          line: 136,
          column: 42
        }
      },
      "62": {
        start: {
          line: 138,
          column: 21
        },
        end: {
          line: 138,
          column: 47
        }
      },
      "63": {
        start: {
          line: 139,
          column: 4
        },
        end: {
          line: 142,
          column: 5
        }
      },
      "64": {
        start: {
          line: 140,
          column: 6
        },
        end: {
          line: 140,
          column: 42
        }
      },
      "65": {
        start: {
          line: 141,
          column: 6
        },
        end: {
          line: 141,
          column: 12
        }
      },
      "66": {
        start: {
          line: 143,
          column: 4
        },
        end: {
          line: 151,
          column: 5
        }
      },
      "67": {
        start: {
          line: 144,
          column: 23
        },
        end: {
          line: 144,
          column: 57
        }
      },
      "68": {
        start: {
          line: 146,
          column: 6
        },
        end: {
          line: 150,
          column: 7
        }
      },
      "69": {
        start: {
          line: 147,
          column: 8
        },
        end: {
          line: 147,
          column: 72
        }
      },
      "70": {
        start: {
          line: 147,
          column: 33
        },
        end: {
          line: 147,
          column: 72
        }
      },
      "71": {
        start: {
          line: 149,
          column: 8
        },
        end: {
          line: 149,
          column: 88
        }
      },
      "72": {
        start: {
          line: 153,
          column: 4
        },
        end: {
          line: 158,
          column: 5
        }
      },
      "73": {
        start: {
          line: 154,
          column: 17
        },
        end: {
          line: 154,
          column: 96
        }
      },
      "74": {
        start: {
          line: 155,
          column: 6
        },
        end: {
          line: 155,
          column: 87
        }
      },
      "75": {
        start: {
          line: 155,
          column: 51
        },
        end: {
          line: 155,
          column: 74
        }
      },
      "76": {
        start: {
          line: 155,
          column: 77
        },
        end: {
          line: 155,
          column: 87
        }
      },
      "77": {
        start: {
          line: 156,
          column: 25
        },
        end: {
          line: 156,
          column: 64
        }
      },
      "78": {
        start: {
          line: 157,
          column: 6
        },
        end: {
          line: 157,
          column: 81
        }
      },
      "79": {
        start: {
          line: 157,
          column: 55
        },
        end: {
          line: 157,
          column: 81
        }
      },
      "80": {
        start: {
          line: 162,
          column: 38
        },
        end: {
          line: 162,
          column: 48
        }
      },
      "81": {
        start: {
          line: 163,
          column: 4
        },
        end: {
          line: 163,
          column: 34
        }
      },
      "82": {
        start: {
          line: 163,
          column: 23
        },
        end: {
          line: 163,
          column: 34
        }
      },
      "83": {
        start: {
          line: 164,
          column: 4
        },
        end: {
          line: 167,
          column: 5
        }
      },
      "84": {
        start: {
          line: 165,
          column: 6
        },
        end: {
          line: 165,
          column: 42
        }
      },
      "85": {
        start: {
          line: 166,
          column: 6
        },
        end: {
          line: 166,
          column: 47
        }
      },
      "86": {
        start: {
          line: 168,
          column: 4
        },
        end: {
          line: 168,
          column: 28
        }
      },
      "87": {
        start: {
          line: 186,
          column: 8
        },
        end: {
          line: 186,
          column: 18
        }
      },
      "88": {
        start: {
          line: 187,
          column: 18
        },
        end: {
          line: 192,
          column: 5
        }
      },
      "89": {
        start: {
          line: 188,
          column: 21
        },
        end: {
          line: 188,
          column: 72
        }
      },
      "90": {
        start: {
          line: 189,
          column: 47
        },
        end: {
          line: 189,
          column: 74
        }
      },
      "91": {
        start: {
          line: 193,
          column: 16
        },
        end: {
          line: 193,
          column: 18
        }
      },
      "92": {
        start: {
          line: 194,
          column: 15
        },
        end: {
          line: 194,
          column: 16
        }
      },
      "93": {
        start: {
          line: 195,
          column: 4
        },
        end: {
          line: 243,
          column: 5
        }
      },
      "94": {
        start: {
          line: 196,
          column: 6
        },
        end: {
          line: 242,
          column: 7
        }
      },
      "95": {
        start: {
          line: 197,
          column: 8
        },
        end: {
          line: 197,
          column: 17
        }
      },
      "96": {
        start: {
          line: 198,
          column: 13
        },
        end: {
          line: 242,
          column: 7
        }
      },
      "97": {
        start: {
          line: 211,
          column: 12
        },
        end: {
          line: 211,
          column: 22
        }
      },
      "98": {
        start: {
          line: 212,
          column: 25
        },
        end: {
          line: 212,
          column: 30
        }
      },
      "99": {
        start: {
          line: 213,
          column: 8
        },
        end: {
          line: 215,
          column: 9
        }
      },
      "100": {
        start: {
          line: 214,
          column: 10
        },
        end: {
          line: 214,
          column: 58
        }
      },
      "101": {
        start: {
          line: 217,
          column: 10
        },
        end: {
          line: 237,
          column: 12
        }
      },
      "102": {
        start: {
          line: 239,
          column: 8
        },
        end: {
          line: 239,
          column: 20
        }
      },
      "103": {
        start: {
          line: 241,
          column: 8
        },
        end: {
          line: 241,
          column: 55
        }
      },
      "104": {
        start: {
          line: 241,
          column: 29
        },
        end: {
          line: 241,
          column: 55
        }
      },
      "105": {
        start: {
          line: 245,
          column: 20
        },
        end: {
          line: 245,
          column: 87
        }
      },
      "106": {
        start: {
          line: 246,
          column: 4
        },
        end: {
          line: 248,
          column: 5
        }
      },
      "107": {
        start: {
          line: 247,
          column: 6
        },
        end: {
          line: 247,
          column: 69
        }
      },
      "108": {
        start: {
          line: 249,
          column: 15
        },
        end: {
          line: 249,
          column: 90
        }
      },
      "109": {
        start: {
          line: 250,
          column: 19
        },
        end: {
          line: 254,
          column: 5
        }
      },
      "110": {
        start: {
          line: 255,
          column: 4
        },
        end: {
          line: 261,
          column: 5
        }
      },
      "111": {
        start: {
          line: 256,
          column: 6
        },
        end: {
          line: 260,
          column: 7
        }
      },
      "112": {
        start: {
          line: 263,
          column: 4
        },
        end: {
          line: 263,
          column: 17
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 19,
            column: 28
          },
          end: {
            line: 19,
            column: 29
          }
        },
        loc: {
          start: {
            line: 19,
            column: 58
          },
          end: {
            line: 26,
            column: 1
          }
        },
        line: 19
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 23,
            column: 26
          },
          end: {
            line: 23,
            column: 27
          }
        },
        loc: {
          start: {
            line: 23,
            column: 31
          },
          end: {
            line: 23,
            column: 55
          }
        },
        line: 23
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 52,
            column: 2
          },
          end: {
            line: 52,
            column: 3
          }
        },
        loc: {
          start: {
            line: 52,
            column: 47
          },
          end: {
            line: 60,
            column: 3
          }
        },
        line: 52
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 62,
            column: 2
          },
          end: {
            line: 62,
            column: 3
          }
        },
        loc: {
          start: {
            line: 62,
            column: 22
          },
          end: {
            line: 65,
            column: 3
          }
        },
        line: 62
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 67,
            column: 2
          },
          end: {
            line: 67,
            column: 3
          }
        },
        loc: {
          start: {
            line: 67,
            column: 58
          },
          end: {
            line: 75,
            column: 3
          }
        },
        line: 67
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 70,
            column: 50
          },
          end: {
            line: 70,
            column: 51
          }
        },
        loc: {
          start: {
            line: 70,
            column: 70
          },
          end: {
            line: 70,
            column: 76
          }
        },
        line: 70
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 71,
            column: 11
          },
          end: {
            line: 71,
            column: 12
          }
        },
        loc: {
          start: {
            line: 71,
            column: 17
          },
          end: {
            line: 73,
            column: 7
          }
        },
        line: 71
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 77,
            column: 2
          },
          end: {
            line: 77,
            column: 3
          }
        },
        loc: {
          start: {
            line: 77,
            column: 33
          },
          end: {
            line: 98,
            column: 3
          }
        },
        line: 77
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 100,
            column: 2
          },
          end: {
            line: 100,
            column: 3
          }
        },
        loc: {
          start: {
            line: 100,
            column: 34
          },
          end: {
            line: 103,
            column: 3
          }
        },
        line: 100
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 105,
            column: 2
          },
          end: {
            line: 105,
            column: 3
          }
        },
        loc: {
          start: {
            line: 105,
            column: 20
          },
          end: {
            line: 112,
            column: 3
          }
        },
        line: 105
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 111,
            column: 19
          },
          end: {
            line: 111,
            column: 20
          }
        },
        loc: {
          start: {
            line: 111,
            column: 25
          },
          end: {
            line: 111,
            column: 43
          }
        },
        line: 111
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 114,
            column: 2
          },
          end: {
            line: 114,
            column: 3
          }
        },
        loc: {
          start: {
            line: 114,
            column: 39
          },
          end: {
            line: 116,
            column: 3
          }
        },
        line: 114
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 118,
            column: 2
          },
          end: {
            line: 118,
            column: 3
          }
        },
        loc: {
          start: {
            line: 118,
            column: 33
          },
          end: {
            line: 122,
            column: 3
          }
        },
        line: 118
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 121,
            column: 39
          },
          end: {
            line: 121,
            column: 40
          }
        },
        loc: {
          start: {
            line: 121,
            column: 44
          },
          end: {
            line: 121,
            column: 62
          }
        },
        line: 121
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 124,
            column: 2
          },
          end: {
            line: 124,
            column: 3
          }
        },
        loc: {
          start: {
            line: 124,
            column: 38
          },
          end: {
            line: 159,
            column: 3
          }
        },
        line: 124
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 155,
            column: 46
          },
          end: {
            line: 155,
            column: 47
          }
        },
        loc: {
          start: {
            line: 155,
            column: 51
          },
          end: {
            line: 155,
            column: 74
          }
        },
        line: 155
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 161,
            column: 2
          },
          end: {
            line: 161,
            column: 3
          }
        },
        loc: {
          start: {
            line: 161,
            column: 17
          },
          end: {
            line: 169,
            column: 3
          }
        },
        line: 161
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 171,
            column: 2
          },
          end: {
            line: 171,
            column: 3
          }
        },
        loc: {
          start: {
            line: 171,
            column: 11
          },
          end: {
            line: 264,
            column: 3
          }
        },
        line: 171
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 188,
            column: 14
          },
          end: {
            line: 188,
            column: 15
          }
        },
        loc: {
          start: {
            line: 188,
            column: 21
          },
          end: {
            line: 188,
            column: 72
          }
        },
        line: 188
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 189,
            column: 14
          },
          end: {
            line: 189,
            column: 15
          }
        },
        loc: {
          start: {
            line: 189,
            column: 47
          },
          end: {
            line: 189,
            column: 74
          }
        },
        line: 189
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 21,
            column: 55
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 21,
            column: 55
          }
        }, {
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 21,
            column: 55
          }
        }],
        line: 21
      },
      "1": {
        loc: {
          start: {
            line: 21,
            column: 6
          },
          end: {
            line: 21,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 21,
            column: 6
          },
          end: {
            line: 21,
            column: 22
          }
        }, {
          start: {
            line: 21,
            column: 26
          },
          end: {
            line: 21,
            column: 42
          }
        }],
        line: 21
      },
      "2": {
        loc: {
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 22,
            column: 82
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 22,
            column: 82
          }
        }, {
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 22,
            column: 82
          }
        }],
        line: 22
      },
      "3": {
        loc: {
          start: {
            line: 22,
            column: 6
          },
          end: {
            line: 22,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 22,
            column: 6
          },
          end: {
            line: 22,
            column: 21
          }
        }, {
          start: {
            line: 22,
            column: 25
          },
          end: {
            line: 22,
            column: 45
          }
        }, {
          start: {
            line: 22,
            column: 49
          },
          end: {
            line: 22,
            column: 68
          }
        }],
        line: 22
      },
      "4": {
        loc: {
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 23,
            column: 70
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 23,
            column: 70
          }
        }, {
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 23,
            column: 70
          }
        }],
        line: 23
      },
      "5": {
        loc: {
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 24,
            column: 37
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 24,
            column: 37
          }
        }, {
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 24,
            column: 37
          }
        }],
        line: 24
      },
      "6": {
        loc: {
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 74,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 74,
            column: 5
          }
        }, {
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 74,
            column: 5
          }
        }],
        line: 69
      },
      "7": {
        loc: {
          start: {
            line: 69,
            column: 8
          },
          end: {
            line: 69,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 69,
            column: 8
          },
          end: {
            line: 69,
            column: 24
          }
        }, {
          start: {
            line: 69,
            column: 28
          },
          end: {
            line: 69,
            column: 39
          }
        }, {
          start: {
            line: 69,
            column: 43
          },
          end: {
            line: 69,
            column: 70
          }
        }],
        line: 69
      },
      "8": {
        loc: {
          start: {
            line: 70,
            column: 19
          },
          end: {
            line: 70,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 70,
            column: 37
          },
          end: {
            line: 70,
            column: 47
          }
        }, {
          start: {
            line: 70,
            column: 50
          },
          end: {
            line: 70,
            column: 76
          }
        }],
        line: 70
      },
      "9": {
        loc: {
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 79,
            column: 55
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 79,
            column: 55
          }
        }, {
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 79,
            column: 55
          }
        }],
        line: 79
      },
      "10": {
        loc: {
          start: {
            line: 79,
            column: 8
          },
          end: {
            line: 79,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 79,
            column: 8
          },
          end: {
            line: 79,
            column: 13
          }
        }, {
          start: {
            line: 79,
            column: 17
          },
          end: {
            line: 79,
            column: 30
          }
        }, {
          start: {
            line: 79,
            column: 34
          },
          end: {
            line: 79,
            column: 47
          }
        }],
        line: 79
      },
      "11": {
        loc: {
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 81,
            column: 62
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 81,
            column: 62
          }
        }, {
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 81,
            column: 62
          }
        }],
        line: 81
      },
      "12": {
        loc: {
          start: {
            line: 81,
            column: 39
          },
          end: {
            line: 81,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 81,
            column: 39
          },
          end: {
            line: 81,
            column: 57
          }
        }, {
          start: {
            line: 81,
            column: 61
          },
          end: {
            line: 81,
            column: 62
          }
        }],
        line: 81
      },
      "13": {
        loc: {
          start: {
            line: 83,
            column: 4
          },
          end: {
            line: 86,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 83,
            column: 4
          },
          end: {
            line: 86,
            column: 5
          }
        }, {
          start: {
            line: 83,
            column: 4
          },
          end: {
            line: 86,
            column: 5
          }
        }],
        line: 83
      },
      "14": {
        loc: {
          start: {
            line: 87,
            column: 4
          },
          end: {
            line: 93,
            column: 12
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 87,
            column: 4
          },
          end: {
            line: 93,
            column: 12
          }
        }, {
          start: {
            line: 87,
            column: 4
          },
          end: {
            line: 93,
            column: 12
          }
        }],
        line: 87
      },
      "15": {
        loc: {
          start: {
            line: 88,
            column: 6
          },
          end: {
            line: 91,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 88,
            column: 6
          },
          end: {
            line: 88,
            column: 35
          }
        }, {
          start: {
            line: 89,
            column: 6
          },
          end: {
            line: 89,
            column: 49
          }
        }, {
          start: {
            line: 90,
            column: 6
          },
          end: {
            line: 90,
            column: 18
          }
        }, {
          start: {
            line: 91,
            column: 6
          },
          end: {
            line: 91,
            column: 41
          }
        }],
        line: 88
      },
      "16": {
        loc: {
          start: {
            line: 107,
            column: 16
          },
          end: {
            line: 107,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 107,
            column: 46
          },
          end: {
            line: 107,
            column: 58
          }
        }, {
          start: {
            line: 107,
            column: 61
          },
          end: {
            line: 107,
            column: 63
          }
        }],
        line: 107
      },
      "17": {
        loc: {
          start: {
            line: 108,
            column: 4
          },
          end: {
            line: 110,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 108,
            column: 4
          },
          end: {
            line: 110,
            column: 5
          }
        }, {
          start: {
            line: 108,
            column: 4
          },
          end: {
            line: 110,
            column: 5
          }
        }],
        line: 108
      },
      "18": {
        loc: {
          start: {
            line: 111,
            column: 25
          },
          end: {
            line: 111,
            column: 43
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 111,
            column: 37
          },
          end: {
            line: 111,
            column: 39
          }
        }, {
          start: {
            line: 111,
            column: 42
          },
          end: {
            line: 111,
            column: 43
          }
        }],
        line: 111
      },
      "19": {
        loc: {
          start: {
            line: 120,
            column: 4
          },
          end: {
            line: 120,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 120,
            column: 4
          },
          end: {
            line: 120,
            column: 42
          }
        }, {
          start: {
            line: 120,
            column: 4
          },
          end: {
            line: 120,
            column: 42
          }
        }],
        line: 120
      },
      "20": {
        loc: {
          start: {
            line: 139,
            column: 4
          },
          end: {
            line: 142,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 139,
            column: 4
          },
          end: {
            line: 142,
            column: 5
          }
        }, {
          start: {
            line: 139,
            column: 4
          },
          end: {
            line: 142,
            column: 5
          }
        }],
        line: 139
      },
      "21": {
        loc: {
          start: {
            line: 139,
            column: 8
          },
          end: {
            line: 139,
            column: 30
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 139,
            column: 8
          },
          end: {
            line: 139,
            column: 16
          }
        }, {
          start: {
            line: 139,
            column: 20
          },
          end: {
            line: 139,
            column: 30
          }
        }],
        line: 139
      },
      "22": {
        loc: {
          start: {
            line: 143,
            column: 4
          },
          end: {
            line: 151,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 143,
            column: 4
          },
          end: {
            line: 151,
            column: 5
          }
        }, {
          start: {
            line: 143,
            column: 4
          },
          end: {
            line: 151,
            column: 5
          }
        }],
        line: 143
      },
      "23": {
        loc: {
          start: {
            line: 146,
            column: 6
          },
          end: {
            line: 150,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 146,
            column: 6
          },
          end: {
            line: 150,
            column: 7
          }
        }, {
          start: {
            line: 146,
            column: 6
          },
          end: {
            line: 150,
            column: 7
          }
        }],
        line: 146
      },
      "24": {
        loc: {
          start: {
            line: 147,
            column: 8
          },
          end: {
            line: 147,
            column: 72
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 147,
            column: 8
          },
          end: {
            line: 147,
            column: 72
          }
        }, {
          start: {
            line: 147,
            column: 8
          },
          end: {
            line: 147,
            column: 72
          }
        }],
        line: 147
      },
      "25": {
        loc: {
          start: {
            line: 149,
            column: 28
          },
          end: {
            line: 149,
            column: 87
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 149,
            column: 39
          },
          end: {
            line: 149,
            column: 48
          }
        }, {
          start: {
            line: 149,
            column: 51
          },
          end: {
            line: 149,
            column: 87
          }
        }],
        line: 149
      },
      "26": {
        loc: {
          start: {
            line: 153,
            column: 4
          },
          end: {
            line: 158,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 153,
            column: 4
          },
          end: {
            line: 158,
            column: 5
          }
        }, {
          start: {
            line: 153,
            column: 4
          },
          end: {
            line: 158,
            column: 5
          }
        }],
        line: 153
      },
      "27": {
        loc: {
          start: {
            line: 155,
            column: 6
          },
          end: {
            line: 155,
            column: 87
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 155,
            column: 6
          },
          end: {
            line: 155,
            column: 87
          }
        }, {
          start: {
            line: 155,
            column: 6
          },
          end: {
            line: 155,
            column: 87
          }
        }],
        line: 155
      },
      "28": {
        loc: {
          start: {
            line: 155,
            column: 10
          },
          end: {
            line: 155,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 155,
            column: 10
          },
          end: {
            line: 155,
            column: 12
          }
        }, {
          start: {
            line: 155,
            column: 16
          },
          end: {
            line: 155,
            column: 29
          }
        }, {
          start: {
            line: 155,
            column: 33
          },
          end: {
            line: 155,
            column: 75
          }
        }],
        line: 155
      },
      "29": {
        loc: {
          start: {
            line: 157,
            column: 6
          },
          end: {
            line: 157,
            column: 81
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 157,
            column: 6
          },
          end: {
            line: 157,
            column: 81
          }
        }, {
          start: {
            line: 157,
            column: 6
          },
          end: {
            line: 157,
            column: 81
          }
        }],
        line: 157
      },
      "30": {
        loc: {
          start: {
            line: 157,
            column: 10
          },
          end: {
            line: 157,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 157,
            column: 10
          },
          end: {
            line: 157,
            column: 20
          }
        }, {
          start: {
            line: 157,
            column: 24
          },
          end: {
            line: 157,
            column: 39
          }
        }, {
          start: {
            line: 157,
            column: 43
          },
          end: {
            line: 157,
            column: 53
          }
        }],
        line: 157
      },
      "31": {
        loc: {
          start: {
            line: 163,
            column: 4
          },
          end: {
            line: 163,
            column: 34
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 163,
            column: 4
          },
          end: {
            line: 163,
            column: 34
          }
        }, {
          start: {
            line: 163,
            column: 4
          },
          end: {
            line: 163,
            column: 34
          }
        }],
        line: 163
      },
      "32": {
        loc: {
          start: {
            line: 164,
            column: 4
          },
          end: {
            line: 167,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 164,
            column: 4
          },
          end: {
            line: 167,
            column: 5
          }
        }, {
          start: {
            line: 164,
            column: 4
          },
          end: {
            line: 167,
            column: 5
          }
        }],
        line: 164
      },
      "33": {
        loc: {
          start: {
            line: 164,
            column: 8
          },
          end: {
            line: 164,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 164,
            column: 8
          },
          end: {
            line: 164,
            column: 46
          }
        }, {
          start: {
            line: 164,
            column: 50
          },
          end: {
            line: 164,
            column: 70
          }
        }],
        line: 164
      },
      "34": {
        loc: {
          start: {
            line: 196,
            column: 6
          },
          end: {
            line: 242,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 196,
            column: 6
          },
          end: {
            line: 242,
            column: 7
          }
        }, {
          start: {
            line: 196,
            column: 6
          },
          end: {
            line: 242,
            column: 7
          }
        }],
        line: 196
      },
      "35": {
        loc: {
          start: {
            line: 198,
            column: 13
          },
          end: {
            line: 242,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 198,
            column: 13
          },
          end: {
            line: 242,
            column: 7
          }
        }, {
          start: {
            line: 198,
            column: 13
          },
          end: {
            line: 242,
            column: 7
          }
        }],
        line: 198
      },
      "36": {
        loc: {
          start: {
            line: 213,
            column: 8
          },
          end: {
            line: 215,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 213,
            column: 8
          },
          end: {
            line: 215,
            column: 9
          }
        }, {
          start: {
            line: 213,
            column: 8
          },
          end: {
            line: 215,
            column: 9
          }
        }],
        line: 213
      },
      "37": {
        loc: {
          start: {
            line: 241,
            column: 8
          },
          end: {
            line: 241,
            column: 55
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 241,
            column: 8
          },
          end: {
            line: 241,
            column: 55
          }
        }, {
          start: {
            line: 241,
            column: 8
          },
          end: {
            line: 241,
            column: 55
          }
        }],
        line: 241
      },
      "38": {
        loc: {
          start: {
            line: 245,
            column: 41
          },
          end: {
            line: 245,
            column: 86
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 245,
            column: 41
          },
          end: {
            line: 245,
            column: 48
          }
        }, {
          start: {
            line: 245,
            column: 53
          },
          end: {
            line: 245,
            column: 85
          }
        }],
        line: 245
      },
      "39": {
        loc: {
          start: {
            line: 245,
            column: 53
          },
          end: {
            line: 245,
            column: 85
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 245,
            column: 71
          },
          end: {
            line: 245,
            column: 77
          }
        }, {
          start: {
            line: 245,
            column: 80
          },
          end: {
            line: 245,
            column: 85
          }
        }],
        line: 245
      },
      "40": {
        loc: {
          start: {
            line: 246,
            column: 4
          },
          end: {
            line: 248,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 246,
            column: 4
          },
          end: {
            line: 248,
            column: 5
          }
        }, {
          start: {
            line: 246,
            column: 4
          },
          end: {
            line: 248,
            column: 5
          }
        }],
        line: 246
      },
      "41": {
        loc: {
          start: {
            line: 249,
            column: 37
          },
          end: {
            line: 249,
            column: 89
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 249,
            column: 37
          },
          end: {
            line: 249,
            column: 63
          }
        }, {
          start: {
            line: 249,
            column: 67
          },
          end: {
            line: 249,
            column: 89
          }
        }],
        line: 249
      },
      "42": {
        loc: {
          start: {
            line: 255,
            column: 4
          },
          end: {
            line: 261,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 255,
            column: 4
          },
          end: {
            line: 261,
            column: 5
          }
        }, {
          start: {
            line: 255,
            column: 4
          },
          end: {
            line: 261,
            column: 5
          }
        }],
        line: 255
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0, 0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0, 0],
      "29": [0, 0],
      "30": [0, 0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _defineProperty from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread2 from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Table/Tr.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component } from 'react';
import classnames from 'classnames';
import { tableClass } from './styles';
import { inputClass } from '../Input/styles';
import { checkinputClass } from '../Checkbox/styles';
import Td from './Td';
import Expand from './Expand';
import { isFunc } from '../utils/is';
export var ROW_HEIGHT_UPDATE_EVENT = (cov_1j10ih41en.s[0]++, 'ROW_HEIGHT_UPDATE_EVENT_NAME');
var preventClasses = (cov_1j10ih41en.s[1]++, [inputClass('_'), checkinputClass('_'), tableClass('icon-tree-plus'), tableClass('icon-tree-sub')]);
cov_1j10ih41en.s[2]++;

var isExpandableElement = function isExpandableElement(el) {
  cov_1j10ih41en.f[0]++;

  var _ref = (cov_1j10ih41en.s[3]++, el),
      tagName = _ref.tagName;

  cov_1j10ih41en.s[4]++;

  if ((cov_1j10ih41en.b[1][0]++, tagName === 'TD') || (cov_1j10ih41en.b[1][1]++, tagName === 'TR')) {
    cov_1j10ih41en.b[0][0]++;
    cov_1j10ih41en.s[5]++;
    return true;
  } else {
    cov_1j10ih41en.b[0][1]++;
  }

  cov_1j10ih41en.s[6]++;

  if ((cov_1j10ih41en.b[3][0]++, tagName === 'A') || (cov_1j10ih41en.b[3][1]++, tagName === 'BUTTON') || (cov_1j10ih41en.b[3][2]++, tagName === 'INPUT')) {
    cov_1j10ih41en.b[2][0]++;
    cov_1j10ih41en.s[7]++;
    return false;
  } else {
    cov_1j10ih41en.b[2][1]++;
  }

  cov_1j10ih41en.s[8]++;

  if (preventClasses.find(function (c) {
    cov_1j10ih41en.f[1]++;
    cov_1j10ih41en.s[9]++;
    return el.classList.contains(c);
  })) {
    cov_1j10ih41en.b[4][0]++;
    cov_1j10ih41en.s[10]++;
    return false;
  } else {
    cov_1j10ih41en.b[4][1]++;
  }

  cov_1j10ih41en.s[11]++;

  if (!el.parentElement) {
    cov_1j10ih41en.b[5][0]++;
    cov_1j10ih41en.s[12]++;
    return false;
  } else {
    cov_1j10ih41en.b[5][1]++;
  }

  cov_1j10ih41en.s[13]++;
  return isExpandableElement(el.parentElement);
};

var DefaultProps = (cov_1j10ih41en.s[14]++, {
  rowClickAttr: ['*'],
  lazy: true
});

var Tr =
/*#__PURE__*/
function (_Component) {
  _inherits(Tr, _Component);

  var _super = _createSuper2(Tr);

  function Tr(props) {
    var _this;

    _classCallCheck(this, Tr);

    cov_1j10ih41en.f[2]++;
    cov_1j10ih41en.s[15]++;
    _this = _super.call(this, props);
    _this.manualExpand = void 0;
    _this.expandHeight = void 0;
    _this.element = void 0;
    _this.lastRowHeight = void 0;
    _this.lastExpandHeight = void 0;
    _this.lastIndex = void 0;
    _this.lastExpandRender = void 0;
    _this.cachedExpand = void 0;
    cov_1j10ih41en.s[16]++;
    _this.manualExpand = false;
    cov_1j10ih41en.s[17]++;
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    cov_1j10ih41en.s[18]++;
    _this.handleRowClick = _this.handleRowClick.bind(_assertThisInitialized(_this));
    cov_1j10ih41en.s[19]++;
    _this.setRowHeight = _this.setRowHeight.bind(_assertThisInitialized(_this));
    cov_1j10ih41en.s[20]++;
    _this.setExpandHeight = _this.setExpandHeight.bind(_assertThisInitialized(_this));
    cov_1j10ih41en.s[21]++;
    _this.expandHeight = 0;
    return _this;
  }

  _createClass(Tr, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_1j10ih41en.f[3]++;
      cov_1j10ih41en.s[22]++;
      this.manualExpand = true;
      cov_1j10ih41en.s[23]++;
      this.setRowHeight();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      cov_1j10ih41en.f[4]++;

      var _ref2 = (cov_1j10ih41en.s[24]++, this.props),
          hasNotRenderRows = _ref2.hasNotRenderRows,
          dataUpdated = _ref2.dataUpdated,
          columnResizable = _ref2.columnResizable,
          resize = _ref2.resize;

      cov_1j10ih41en.s[25]++;

      if ((cov_1j10ih41en.b[7][0]++, hasNotRenderRows) || (cov_1j10ih41en.b[7][1]++, dataUpdated) || (cov_1j10ih41en.b[7][2]++, prevProps.resize !== resize)) {
        cov_1j10ih41en.b[6][0]++;
        var exec = (cov_1j10ih41en.s[26]++, columnResizable ? (cov_1j10ih41en.b[8][0]++, setTimeout) : (cov_1j10ih41en.b[8][1]++, function (func) {
          cov_1j10ih41en.f[5]++;
          cov_1j10ih41en.s[27]++;
          return func();
        }));
        cov_1j10ih41en.s[28]++;
        exec(function () {
          cov_1j10ih41en.f[6]++;
          cov_1j10ih41en.s[29]++;

          _this2.setRowHeight();
        });
      } else {
        cov_1j10ih41en.b[6][1]++;
      }
    }
  }, {
    key: "setRowHeight",
    value: function setRowHeight(expand) {
      cov_1j10ih41en.f[7]++;

      var _ref3 = (cov_1j10ih41en.s[30]++, this.props),
          setRowHeight = _ref3.setRowHeight,
          dataUpdated = _ref3.dataUpdated,
          datum = _ref3.datum,
          lazy = _ref3.lazy;

      cov_1j10ih41en.s[31]++;

      if ((cov_1j10ih41en.b[10][0]++, !lazy) || (cov_1j10ih41en.b[10][1]++, !setRowHeight) || (cov_1j10ih41en.b[10][2]++, !this.element)) {
        cov_1j10ih41en.b[9][0]++;
        cov_1j10ih41en.s[32]++;
        return;
      } else {
        cov_1j10ih41en.b[9][1]++;
      }

      var _ref4 = (cov_1j10ih41en.s[33]++, this.element.getBoundingClientRect()),
          height = _ref4.height;

      cov_1j10ih41en.s[34]++;

      if (Number.isNaN(height)) {
        cov_1j10ih41en.b[11][0]++;
        cov_1j10ih41en.s[35]++;
        height = (cov_1j10ih41en.b[12][0]++, this.lastRowHeight) || (cov_1j10ih41en.b[12][1]++, 0);
      } else {
        cov_1j10ih41en.b[11][1]++;
      }

      cov_1j10ih41en.s[36]++;
      datum.unsubscribe(ROW_HEIGHT_UPDATE_EVENT, this.setRowHeight);
      cov_1j10ih41en.s[37]++;

      if (height === 0) {
        cov_1j10ih41en.b[13][0]++;
        cov_1j10ih41en.s[38]++;
        datum.subscribe(ROW_HEIGHT_UPDATE_EVENT, this.setRowHeight);
        cov_1j10ih41en.s[39]++;
        return;
      } else {
        cov_1j10ih41en.b[13][1]++;
      }

      cov_1j10ih41en.s[40]++;

      if ((cov_1j10ih41en.b[15][0]++, height === this.lastRowHeight) && (cov_1j10ih41en.b[15][1]++, this.expandHeight === this.lastExpandHeight) && (cov_1j10ih41en.b[15][2]++, !dataUpdated) && (cov_1j10ih41en.b[15][3]++, this.lastIndex === this.props.index)) {
        cov_1j10ih41en.b[14][0]++;
        cov_1j10ih41en.s[41]++;
        return;
      } else {
        cov_1j10ih41en.b[14][1]++;
      }

      cov_1j10ih41en.s[42]++;
      this.lastRowHeight = height;
      cov_1j10ih41en.s[43]++;
      this.lastIndex = this.props.index;
      cov_1j10ih41en.s[44]++;
      this.lastExpandHeight = this.expandHeight;
      cov_1j10ih41en.s[45]++;
      setRowHeight(height + this.expandHeight, this.props.index, !!expand);
    }
  }, {
    key: "setExpandHeight",
    value: function setExpandHeight(height) {
      cov_1j10ih41en.f[8]++;
      cov_1j10ih41en.s[46]++;
      this.expandHeight = height;
      cov_1j10ih41en.s[47]++;
      this.setRowHeight(this.manualExpand);
    }
  }, {
    key: "getRowClickAttr",
    value: function getRowClickAttr() {
      cov_1j10ih41en.f[9]++;

      var _ref5 = (cov_1j10ih41en.s[48]++, this.props),
          rowClickAttr = _ref5.rowClickAttr;

      var res = (cov_1j10ih41en.s[49]++, Array.isArray(rowClickAttr) ? (cov_1j10ih41en.b[16][0]++, rowClickAttr) : (cov_1j10ih41en.b[16][1]++, []));
      cov_1j10ih41en.s[50]++;

      if (typeof rowClickAttr === 'string') {
        cov_1j10ih41en.b[17][0]++;
        cov_1j10ih41en.s[51]++;
        res.push(rowClickAttr);
      } else {
        cov_1j10ih41en.b[17][1]++;
      }

      cov_1j10ih41en.s[52]++;
      return res.map(function (v) {
        cov_1j10ih41en.f[10]++;
        cov_1j10ih41en.s[53]++;
        return v === '*' ? (cov_1j10ih41en.b[18][0]++, '') : (cov_1j10ih41en.b[18][1]++, v);
      });
    }
  }, {
    key: "bindElement",
    value: function bindElement(el) {
      cov_1j10ih41en.f[11]++;
      cov_1j10ih41en.s[54]++;
      this.element = el;
    }
  }, {
    key: "isFireElement",
    value: function isFireElement(el) {
      cov_1j10ih41en.f[12]++;

      var _ref6 = (cov_1j10ih41en.s[55]++, this.props),
          rowClickAttr = _ref6.rowClickAttr;

      cov_1j10ih41en.s[56]++;

      if (rowClickAttr === true) {
        cov_1j10ih41en.b[19][0]++;
        cov_1j10ih41en.s[57]++;
        return true;
      } else {
        cov_1j10ih41en.b[19][1]++;
      }

      cov_1j10ih41en.s[58]++;
      return this.getRowClickAttr().find(function (v) {
        cov_1j10ih41en.f[13]++;
        cov_1j10ih41en.s[59]++;
        return el.hasAttribute(v);
      });
    }
  }, {
    key: "handleRowClick",
    value: function handleRowClick(e) {
      cov_1j10ih41en.f[14]++;

      var _ref7 = (cov_1j10ih41en.s[60]++, this.props),
          columns = _ref7.columns,
          rowData = _ref7.rowData,
          index = _ref7.index,
          onRowClick = _ref7.onRowClick,
          externalExpandRender = _ref7.externalExpandRender,
          externalExpandClick = _ref7.externalExpandClick,
          onExpand = _ref7.onExpand,
          originKey = _ref7.originKey,
          expandRender = _ref7.expandRender;

      var target = (cov_1j10ih41en.s[61]++, e.target); // business needed #row click to modal drawer

      var fireAttr = (cov_1j10ih41en.s[62]++, this.isFireElement(target));
      cov_1j10ih41en.s[63]++;

      if ((cov_1j10ih41en.b[21][0]++, fireAttr) && (cov_1j10ih41en.b[21][1]++, onRowClick)) {
        cov_1j10ih41en.b[20][0]++;
        cov_1j10ih41en.s[64]++;
        onRowClick(rowData, index, fireAttr);
        cov_1j10ih41en.s[65]++;
        return;
      } else {
        cov_1j10ih41en.b[20][1]++;
      }

      cov_1j10ih41en.s[66]++;

      if (externalExpandRender) {
        cov_1j10ih41en.b[22][0]++;
        var expanded = (cov_1j10ih41en.s[67]++, typeof expandRender === 'function'); // @ts-ignore seems to be useless because expandKeys always undefined

        cov_1j10ih41en.s[68]++;

        if (this.props.expandKeys) {
          cov_1j10ih41en.b[23][0]++;
          cov_1j10ih41en.s[69]++;

          if (externalExpandClick) {
            cov_1j10ih41en.b[24][0]++;
            cov_1j10ih41en.s[70]++;
            externalExpandClick(rowData, !expanded);
          } else {
            cov_1j10ih41en.b[24][1]++;
          }
        } else {
          cov_1j10ih41en.b[23][1]++;
          cov_1j10ih41en.s[71]++;
          onExpand(originKey, expanded ? (cov_1j10ih41en.b[25][0]++, undefined) : (cov_1j10ih41en.b[25][1]++, externalExpandRender(rowData, index)));
        }
      } else {
        cov_1j10ih41en.b[22][1]++;
      }

      cov_1j10ih41en.s[72]++;

      if (isExpandableElement(target)) {
        cov_1j10ih41en.b[26][0]++;
        var el = (cov_1j10ih41en.s[73]++, this.element.querySelector(".".concat(tableClass('expand-indicator'))));
        cov_1j10ih41en.s[74]++;

        if ((cov_1j10ih41en.b[28][0]++, el) && (cov_1j10ih41en.b[28][1]++, el !== target) && (cov_1j10ih41en.b[28][2]++, columns.some(function (c) {
          cov_1j10ih41en.f[15]++;
          cov_1j10ih41en.s[75]++;
          return c.type === 'row-expand';
        }))) {
          cov_1j10ih41en.b[27][0]++;
          cov_1j10ih41en.s[76]++;
          el.click();
        } else {
          cov_1j10ih41en.b[27][1]++;
        }

        var matchBlank = (cov_1j10ih41en.s[77]++, this.getRowClickAttr().indexOf('') >= 0);
        cov_1j10ih41en.s[78]++;

        if ((cov_1j10ih41en.b[30][0]++, onRowClick) && (cov_1j10ih41en.b[30][1]++, e.target !== el) && (cov_1j10ih41en.b[30][2]++, matchBlank)) {
          cov_1j10ih41en.b[29][0]++;
          cov_1j10ih41en.s[79]++;
          onRowClick(rowData, index);
        } else {
          cov_1j10ih41en.b[29][1]++;
        }
      } else {
        cov_1j10ih41en.b[26][1]++;
      }
    }
  }, {
    key: "renderExpand",
    value: function renderExpand() {
      cov_1j10ih41en.f[16]++;

      var _ref8 = (cov_1j10ih41en.s[80]++, this.props),
          expandRender = _ref8.expandRender,
          rowData = _ref8.rowData;

      cov_1j10ih41en.s[81]++;

      if (!expandRender) {
        cov_1j10ih41en.b[31][0]++;
        cov_1j10ih41en.s[82]++;
        return null;
      } else {
        cov_1j10ih41en.b[31][1]++;
      }

      cov_1j10ih41en.s[83]++;

      if ((cov_1j10ih41en.b[33][0]++, this.lastExpandRender !== expandRender) && (cov_1j10ih41en.b[33][1]++, isFunc(expandRender))) {
        cov_1j10ih41en.b[32][0]++;
        cov_1j10ih41en.s[84]++;
        this.lastExpandRender = expandRender;
        cov_1j10ih41en.s[85]++;
        this.cachedExpand = expandRender(rowData);
      } else {
        cov_1j10ih41en.b[32][1]++;
      }

      cov_1j10ih41en.s[86]++;
      return this.cachedExpand;
    }
  }, {
    key: "render",
    value: function render() {
      cov_1j10ih41en.f[17]++;

      var _ref9 = (cov_1j10ih41en.s[87]++, this.props),
          columns = _ref9.columns,
          data = _ref9.data,
          rowData = _ref9.rowData,
          striped = _ref9.striped,
          index = _ref9.index,
          expandRender = _ref9.expandRender,
          offsetLeft = _ref9.offsetLeft,
          offsetRight = _ref9.offsetRight,
          hasNotRenderRows = _ref9.hasNotRenderRows,
          rowClassName = _ref9.rowClassName,
          treeExpandKeys = _ref9.treeExpandKeys,
          rowEvents = _ref9.rowEvents,
          reset = _objectWithoutProperties(_ref9, ["columns", "data", "rowData", "striped", "index", "expandRender", "offsetLeft", "offsetRight", "hasNotRenderRows", "rowClassName", "treeExpandKeys", "rowEvents"]);

      var other = (cov_1j10ih41en.s[88]++, Object.keys(reset).filter(function (key) {
        cov_1j10ih41en.f[18]++;
        cov_1j10ih41en.s[89]++;
        return !['format', 'prediction', 'onChange'].includes(key);
      }).reduce(function (r, key) {
        cov_1j10ih41en.f[19]++;
        cov_1j10ih41en.s[90]++;
        return _objectSpread2(_objectSpread2({}, r), {}, _defineProperty({}, key, reset[key]));
      }, {}));
      var tds = (cov_1j10ih41en.s[91]++, []);
      var skip = (cov_1j10ih41en.s[92]++, 0);
      cov_1j10ih41en.s[93]++;

      for (var i = 0, c = columns.length; i < c; i++) {
        cov_1j10ih41en.s[94]++;

        if (skip > 0) {
          cov_1j10ih41en.b[34][0]++;
          cov_1j10ih41en.s[95]++;
          skip -= 1;
        } else {
          cov_1j10ih41en.b[34][1]++;
          cov_1j10ih41en.s[96]++;

          if (data[i]) {
            cov_1j10ih41en.b[35][0]++;

            var _ref10 = (cov_1j10ih41en.s[97]++, columns[i]),
                _className = _ref10.className,
                style = _ref10.style,
                key = _ref10.key,
                fixed = _ref10.fixed,
                lastFixed = _ref10.lastFixed,
                firstFixed = _ref10.firstFixed,
                type = _ref10.type,
                render = _ref10.render,
                onClick = _ref10.onClick,
                align = _ref10.align,
                treeColumnsName = _ref10.treeColumnsName;

            var treeExpand = (cov_1j10ih41en.s[98]++, false);
            cov_1j10ih41en.s[99]++;

            if (treeExpandKeys instanceof Map) {
              cov_1j10ih41en.b[36][0]++;
              cov_1j10ih41en.s[100]++;
              treeExpand = treeExpandKeys.has(other.originKey);
            } else {
              cov_1j10ih41en.b[36][1]++;
            }

            var td = (cov_1j10ih41en.s[101]++,
            /*#__PURE__*/
            React.createElement(Td, Object.assign({}, other, {
              expanded: typeof expandRender === 'function',
              key: key,
              treeExpand: treeExpand,
              treeExpandShow: !!treeColumnsName,
              type: type,
              expandClick: onClick,
              className: _className,
              style: style,
              fixed: fixed,
              firstFixed: firstFixed,
              lastFixed: lastFixed,
              align: align,
              render: render // @ts-ignore  这儿重复了
              ,
              index: index
            }, data[i], {
              offsetLeft: offsetLeft,
              offsetRight: offsetRight,
              __self: this,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 217,
                columnNumber: 11
              }
            })));
            cov_1j10ih41en.s[102]++;
            tds.push(td);
            cov_1j10ih41en.s[103]++;

            if (data[i].colSpan) {
              cov_1j10ih41en.b[37][0]++;
              cov_1j10ih41en.s[104]++;
              skip = data[i].colSpan - 1;
            } else {
              cov_1j10ih41en.b[37][1]++;
            }
          } else {
            cov_1j10ih41en.b[35][1]++;
          }
        }
      }

      var className = (cov_1j10ih41en.s[105]++, tableClass('normal', (cov_1j10ih41en.b[38][0]++, striped) && (cov_1j10ih41en.b[38][1]++, index % 2 === 1 ? (cov_1j10ih41en.b[39][0]++, 'even') : (cov_1j10ih41en.b[39][1]++, 'odd'))));
      cov_1j10ih41en.s[106]++;

      if (rowClassName) {
        cov_1j10ih41en.b[40][0]++;
        cov_1j10ih41en.s[107]++;
        className = classnames(className, rowClassName(rowData, index));
      } else {
        cov_1j10ih41en.b[40][1]++;
      }

      var mc = (cov_1j10ih41en.s[108]++, classnames(className, (cov_1j10ih41en.b[41][0]++, other.datum.check(rowData)) && (cov_1j10ih41en.b[41][1]++, tableClass('selected'))));
      var result = (cov_1j10ih41en.s[109]++, [
      /*#__PURE__*/
      React.createElement("tr", Object.assign({
        key: "0"
      }, rowEvents, {
        onClick: this.handleRowClick,
        className: mc,
        ref: this.bindElement,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 251,
          columnNumber: 7
        }
      }), tds)]);
      cov_1j10ih41en.s[110]++;

      if (expandRender) {
        cov_1j10ih41en.b[42][0]++;
        cov_1j10ih41en.s[111]++;
        result.push(
        /*#__PURE__*/
        React.createElement(Expand, {
          key: "1",
          setExpandHeight: this.setExpandHeight,
          colSpan: columns.length,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 257,
            columnNumber: 9
          }
        }, this.renderExpand()));
      } else {
        cov_1j10ih41en.b[42][1]++;
      }

      cov_1j10ih41en.s[112]++;
      return result;
    }
  }]);

  return Tr;
}(Component);

Tr.displayName = 'ShineoutTr';
Tr.defaultProps = DefaultProps;
export default Tr;